import React from 'react';
import { useDispatch } from 'react-redux';

import {
  COLOURFUL_TEMPLATE_NAME,
  COMMENT_DESIRABILITY,
} from '../../../utils/const';
import SectionHeader from '../../../components/SectionHeader';
import PortfolioCommentIcon from '../../../components/PortfolioCommentIcon';
import SvgIcon from '../../../components/SvgIcon';

const Desirability = ({
  data: { description },
  locales: { portfolio },
  className,
  backgroundSection,
  sectionHeaderTitleColor,
  descriptionColor,
  mainSvgColor,
  templateName,
  disabled = false,
}) => {
  const {
    portfolio: { updateSectionField },
  } = useDispatch();

  return (
    <div
      className={`${className} relative`}
      style={{ backgroundColor: backgroundSection }}
    >
      <PortfolioCommentIcon title={COMMENT_DESIRABILITY} />
      {templateName === COLOURFUL_TEMPLATE_NAME && (
        <div className="svg-funDesirabilityTen" style={{ fill: mainSvgColor }}>
          <SvgIcon name="funDesirabilityTenth" />
        </div>
      )}
      <SectionHeader
        templateName={templateName}
        title={portfolio.desirabilitySection.newSectionName}
        description={description}
        onChange={(e) =>
          updateSectionField({
            sectionName: 'desirabilitySection',
            field: 'description',
            name: 'desirabilityText',
            value: e.target.value,
          })
        }
        portfolio={portfolio}
        style={{ color: sectionHeaderTitleColor }}
        descriptionColor={descriptionColor}
        disabled={disabled}
      />
    </div>
  );
};

export default Desirability;
